import React from 'react';
//import logo from './assets/visioN.svg';
import '../App.less';
import { 
    Button,
    Typography, 
    Divider,
    Row, 
    Col,
    Card,
    Image,
    Space,
    Avatar,
    Tabs
  } from 'antd';

import { Link } from "react-router-dom";

const { 
  Text, 
  Title
} = Typography;

const gridStyle = {
  width: '50%',
  textAlign: 'center',
};

function UIUX() {
    return (
        <div>
          <Row justify="space-between">
            <Col xs={24} sm={24} md={24} lg={12} xl={12}>
              <Space size={8} direction={'vertical'}>
                <Image className="divImage m16-t" src="https://cdn.dribbble.com/users/276151/screenshots/3674563/cleartax-logo.gif"/>
                <Text className="imgDesc">ClearTax logo rebrand</Text>
              </Space>
            </Col>
            <Col xs={24} sm={24} md={24} lg={11} xl={11}>
              <Space size={8} direction={'vertical'}>
                <Image className="divImage m16-t" src="https://cdn.dribbble.com/users/276151/screenshots/4830322/category-icons.gif"/>
                <Text className="imgDesc">Exam icons for Unacademy - Fresh icon set to visually aid learners to select what they are looking to study</Text>
              </Space>
            </Col>
          </Row>
          <Row justify="space-between">
            <Col xs={24} sm={24} md={24} lg={24} xl={24}>
              <Space size={8} direction={'vertical'}>
                <Image className="divImage m24-t" src="https://uploads-ssl.webflow.com/5c780e41a9a4158144c155ce/5c7a74a29254e958abc0d536_Screenshot%202019-03-02%20at%205.48.20%20PM.png"/>
                <Text className="imgDesc">Unacademy Icon set - Previously Material Deign icon set was being used and frequently we had to come up with custom icons because of the edtech domain of the product. Made this icon set to complement the Unacademy apps. This icon is set is ever growing and now has close to 130 icons. Made in illustrator and converted to .TTF using icomoon app. Here are a few:</Text>
              </Space>
            </Col>
          </Row>
          <Row justify="space-between">
            <Col xs={24} sm={24} md={24} lg={12} xl={12}>
              <Space size={8} direction={'vertical'}>
                <Image className="divImage m24-t" src="https://cdn.dribbble.com/users/276151/screenshots/2153461/loader.gif"/>
                <Text className="imgDesc">Droplet inspired loader</Text>
              </Space>
            </Col>
            <Col xs={24} sm={24} md={24} lg={11} xl={11}>
              <Space size={8} direction={'vertical'}>
                <Image className="divImage m24-t" src="https://cdn.dribbble.com/users/276151/screenshots/2155299/piggy_bank.gif"/>
                <Text className="imgDesc">Was wondering why is it called a piggy bank and ended up make this</Text>
              </Space>
            </Col>
          </Row>
          <Row justify="space-between">
            <Col xs={24} sm={24} md={24} lg={12} xl={12}>
              <Space size={8} direction={'vertical'}>
                <Image className="divImage m24-t" src="https://cdn.dribbble.com/users/276151/screenshots/1873091/scarlett_johansson.jpg"/>
                <Text className="imgDesc">Scarlett</Text>
              </Space>
            </Col>
            <Col xs={24} sm={24} md={24} lg={11} xl={11}>
              <Space size={8} direction={'vertical'}>
                <Image className="divImage m24-t" src="https://cdn.dribbble.com/users/276151/screenshots/2094464/world-environment-day.png"/>
                <Text className="imgDesc">Happy World Environment Day 2050 - A different perspective to see home from or home that was. This illustration can be interpreted in both ways depending on what actions we take now.</Text>
              </Space>
            </Col>
          </Row>
          <Row justify="space-between m24-t">
            <Col xs={24} sm={24} md={24} lg={24} xl={24}>
              <Space size={8} direction={'vertical'}>
                <iframe width="560" height="315" src="https://www.youtube.com/embed/mokpoM7GYk8" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                <Text className="imgDesc">Jaipuriya Swag - Based on an actual artwork behind an auto in Jaipur, known as the pink city. This auto perfectly captures Rajashthani folks. As soon as I saw this photograph taken by, I knew I had to illustrate i right away.</Text>
              </Space>
            </Col>
          </Row>
        </div>
        );
  }
  
export default UIUX;
